import { useRouter } from "next/router";
import clansmen from "public/images/HighlandClansmen.jpg";
import charm from "public/images/LuckyCharm.png";
import { BiMenu } from "react-icons/bi";

import {
  FeatureNavListItem,
  Header,
  InternalLink,
  Line,
  NavLink,
  NavListItem,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuTrigger,
  SecondaryNavLink,
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@sorcery/ui";

import { useUser } from "~/providers/UserProvider";
import {
  cardsPath,
  // codexesPath,
  collectionPath,
  decksPath,
  homePath,
  locatorPath,
  loginPath,
  logoutPath,
  newsPath,
  playNetworkPath,
  preconsPath,
  userPath,
} from "~/utils/paths";
import { Logo } from "../../atoms/Logo";
import { CreateDeck } from "./CreateDeck";
import { InAppNotifications } from "./InAppNotifications";
import { Search } from "./Search";

export const HeaderDecorator = () => {
  const { user } = useUser();
  const { asPath } = useRouter();

  return (
    <Header
      className="mt-3"
      logo={
        <div className="w-[8rem] cursor-pointer sm:w-[10rem] md:w-[11rem]">
          <InternalLink href={homePath}>
            <Logo />
          </InternalLink>
        </div>
      }
      leftLinks={
        <>
          <NavigationMenuItem>
            <NavLink path={cardsPath} label="Cards" />
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuTrigger>Decks</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[430px] grid-cols-[1.05fr_0.95fr] gap-3 p-6">
                <FeatureNavListItem
                  path={decksPath}
                  label="Decks"
                  subtitle="The Deck Library"
                  src={charm}
                />
                <NavListItem
                  label="Tournament Decks"
                  disabled={true}
                  path={"dummy"}
                  subtitle="Coming soon..."
                />
                <NavListItem
                  path={preconsPath}
                  label="Precons"
                  subtitle="Ready to Play"
                  className="-mb-1.5"
                />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuTrigger>Play</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[430px] grid-cols-[1.05fr_0.95fr] gap-3 p-6">
                <FeatureNavListItem
                  path={playNetworkPath}
                  label="Play Network"
                  subtitle="Find Nearby Events"
                  src={clansmen}
                />
                <NavListItem
                  path={locatorPath}
                  label="Store Locator"
                  subtitle="Find Nearby Stores"
                />
                <NavListItem
                  path={newsPath}
                  label="News"
                  subtitle="Follow The Latest"
                  className="-mb-1.5"
                />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          {/* <NavigationMenuItem>
            <NavLink path={codexesPath} label="Codex" />
          </NavigationMenuItem> */}

          {user && (
            <NavigationMenuItem className="items-center lg:visible lg:flex">
              <div className="cursor-default pl-5 pr-6 text-lg text-big-text-color text-opacity-60 ">
                {"|"}
              </div>
              <SecondaryNavLink path={userPath(user.id)} label="Account" />
              <SecondaryNavLink path={collectionPath} label="Collection" />
            </NavigationMenuItem>
          )}
        </>
      }
      rightLinks={
        <>
          <NavigationMenuItem>
            <Search />
          </NavigationMenuItem>
          {user ? (
            <>
              <NavigationMenuItem>
                <CreateDeck />
              </NavigationMenuItem>
              <NavigationMenuItem>
                <InAppNotifications />
              </NavigationMenuItem>
              <NavigationMenuItem className="mt-1 hidden lg:visible lg:flex">
                <NavigationMenuTrigger>
                  {user.username
                    ? user.username.slice(0, 12) + (user.username.length > 12 ? " ..." : "")
                    : "Account"}
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <ul className="w-max p-6">
                    <NavListItem path={userPath(user.id)} label={"Account"} />
                    <NavListItem path={collectionPath} label={"Collection"} />
                    <Line className="-mx-2 mb-2 mt-4 h-1 !bg-gray-300 opacity-30" />
                    <NavListItem path={logoutPath} label="Logout" />
                  </ul>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </>
          ) : (
            <NavigationMenuItem className="mt-1 hidden lg:visible lg:flex">
              <NavLink path={loginPath(asPath)} label="Login" />
            </NavigationMenuItem>
          )}
        </>
      }
      popup={
        <div className="visible mt-1 lg:invisible lg:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <button type="button" className="outline-none hover:opacity-60 pl-1">
                <BiMenu
                  size={18}
                  aria-haspopup="true"
                  className="-mt-1 inline-block transition duration-150 ease-in-out animate-in fade-in"
                />
                <span
                  className={
                    "select-none pl-1 font-title text-lg font-bold transition duration-150 ease-in-out"
                  }
                >
                  Menu
                </span>
              </button>
            </SheetTrigger>
            <SheetContent className="flex flex-col gap-3 overflow-y-auto">
              {user ? (
                <>
                  <NavLink path={userPath(user.id)} label={"Account"} />
                  <NavLink path={collectionPath} label="Collection" />
                  <NavLink path={logoutPath} label="Logout" />
                </>
              ) : (
                <NavLink path={loginPath(asPath)} label="Login" />
              )}

              <Line className="my-1 h-1 !bg-gray-300 opacity-30" />
              <NavLink path={cardsPath} label="Cards" />
              <NavLink path={decksPath} label="Decks" />
              {/* <NavLink
                path={"dummy"}
                label="Tournament Decks..."
                disabled={true}
              /> */}
              <NavLink path={preconsPath} label="Precons" />

              <Line className="my-1 h-1 !bg-gray-300 opacity-30" />
              <NavLink path={playNetworkPath} label="Play Network" />
              <NavLink path={locatorPath} label="Store Locator" />
              <NavLink path={newsPath} label="News" />
            </SheetContent>
          </Sheet>
        </div>
      }
    />
  );
};
